import { Component } from '../common/componentUtils';
import { DataPreFilledType } from '../constants';
import { t } from '../utils';
import { DocgenClient } from './docgenClient';
import { DataSourceItem, Entity, Variable } from './interfaces/DocumentTemplate';
import { SchemaResponse } from './interfaces/SchemaResponse';

let entityMap = new Map<string, Entity[]>();
let isFetching = new Map<string, Promise<Entity[]>>();
let schemaMap = new Map<string, SchemaResponse>();
let dataSources = null;

export const fetchDataSources = async () => {
	if (dataSources) {
		return dataSources;
	}
	const response: DataSourceItem[] = await DocgenClient.getDataSources();
	dataSources = response;
	return response;
};
export const fetchEntitiesByDataSource = async (dataSourceConnectionRid: string) => {
	if (isFetching.has(dataSourceConnectionRid)) {
		return isFetching.get(dataSourceConnectionRid);
	}

	const promise = entityFetcher(dataSourceConnectionRid);
	isFetching.set(dataSourceConnectionRid, promise);
	return promise;
};

const entityFetcher = async dataSourceConnectionRid => {
	if (entityMap.has(dataSourceConnectionRid)) {
		return entityMap.get(dataSourceConnectionRid);
	}
	const entities: Entity[] = await DocgenClient.getEntitiesByDataSource(
		dataSourceConnectionRid
	);

	entityMap.set(dataSourceConnectionRid, entities);
	isFetching.delete(dataSourceConnectionRid);

	return entities;
};

export const saveVariables = async (payload, rid) => {
	const response = await DocgenClient.updateDocumentTemplate(payload, rid);
	return response;
};

export const fetchSchema = async (connectionRID, entityId) => {
	if (schemaMap.has(entityId)) {
		return schemaMap.get(entityId);
	}
	const schemaResponse: SchemaResponse = await DocgenClient.getSchema(
		connectionRID,
		entityId
	);

	schemaMap.set(entityId, schemaResponse);
	return schemaResponse;
};

export const updateFieldsOfVariable = (fields: Component[], variables: Variable[]) => {
	if (fields?.length && variables?.length) {
		const updatedFields = fields.map((field: Component) => {
			if (field.dataPreFilledType === DataPreFilledType.SourceMapped) {
				const { variableId, name } = field;
				const variable = variables.find(va => va.id === variableId);
				const [dataSource, , propertyName] = name.split('.');
				field.name = `${dataSource}.${variable?.name}.${propertyName}`;
			}
			return field;
		});

		return updatedFields;
	}
	return fields;
};

export const resetVariablesData = () => {
	entityMap = new Map<string, Entity[]>();
	isFetching = new Map<string, Promise<Entity[]>>();
	schemaMap = new Map<string, SchemaResponse>();
	dataSources = null;
};
